import { useApi } from './useApi'

const BASE_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000'

export const useEstudios = () => {
  const api = useApi()

  // { estudios: [{ id, territorioId, guestGroupId, publicador, whatsapp, estudiante, estudianteWhatsapp, direccion, lat, lng, fechaInicio, aQuienSePaso, observaciones }] }
  const getEstudios = () => api.get('/api/estudios')

  const createEstudio = (payload) => api.post('/api/estudios', payload)

  const updateEstudio = (id, payload) => api.put(`/api/estudios/${id}`, payload)

  const getPublicUrl = (token) =>
    `${window.location.origin}/estudios-publico?token=${token}`

  // Enlace público por grupo de invitados (uno por grupo, idempotente)
  const getEstudioLink = (guestGroupId) => api.get(`/api/estudio-link/${guestGroupId}`)

  const createEstudioLink = (guestGroupId) => api.post(`/api/estudio-link/${guestGroupId}`, {})

  const revokeEstudioLink = (guestGroupId) => api.del(`/api/estudio-link/${guestGroupId}`)

  const fetchPublicEstudios = async (token) => {
    const res = await fetch(`${BASE_URL}/api/public/estudios/${token}`)
    return res.json()
  }

  // payload + archivos (File[]) se envían como multipart/form-data. No fijar el
  // header Content-Type a mano: el navegador arma el boundary automáticamente.
  const toFormData = (payload, files) => {
    const fd = new FormData()
    for (const [key, value] of Object.entries(payload)) {
      if (value !== null && value !== undefined) fd.append(key, value)
    }
    for (const file of files || []) fd.append('archivos', file)
    return fd
  }

  const submitPublicEstudio = async (token, payload, files) => {
    const res = await fetch(`${BASE_URL}/api/public/estudios/${token}`, {
      method: 'POST',
      body: toFormData(payload, files),
    })
    return res.json()
  }

  const updatePublicEstudio = async (token, id, payload, files) => {
    const res = await fetch(`${BASE_URL}/api/public/estudios/${token}/${id}`, {
      method: 'PUT',
      body: toFormData(payload, files),
    })
    return res.json()
  }

  const deletePublicEstudioAdjunto = async (token, id, adjuntoId) => {
    const res = await fetch(`${BASE_URL}/api/public/estudios/${token}/${id}/adjuntos/${adjuntoId}`, {
      method: 'DELETE',
    })
    return res.json()
  }

  const getAdjuntoUrl = (adjuntoId) => `${BASE_URL}/api/public/adjuntos/${adjuntoId}/archivo`

  // Notas de seguimiento de un estudio (visitas, resultados), cargadas por el publicador asignado
  const getEstudioNotas = (estudioId) => api.get(`/api/estudios/${estudioId}/notas`)

  const getPublicUrlAsignacion = (token) =>
    `${window.location.origin}/estudio-asignacion?token=${token}`

  // Enlace público individual por estudio (uno por estudio, idempotente), orientado
  // al publicador al que se le asignó el estudio
  const getEstudioAsignacionLink = (estudioId) => api.get(`/api/estudio-asignacion-link/${estudioId}`)

  const createEstudioAsignacionLink = (estudioId) => api.post(`/api/estudio-asignacion-link/${estudioId}`, {})

  const revokeEstudioAsignacionLink = (estudioId) => api.del(`/api/estudio-asignacion-link/${estudioId}`)

  const fetchPublicEstudioAsignacion = async (token) => {
    const res = await fetch(`${BASE_URL}/api/public/estudio-asignacion/${token}`)
    return res.json()
  }

  const updatePublicAsignacion = async (token, payload) => {
    const res = await fetch(`${BASE_URL}/api/public/estudio-asignacion/${token}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    return res.json()
  }

  const addPublicEstudioNota = async (token, payload) => {
    const res = await fetch(`${BASE_URL}/api/public/estudio-asignacion/${token}/notas`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    return res.json()
  }

  return {
    getEstudios,
    createEstudio,
    updateEstudio,
    getPublicUrl,
    getEstudioLink,
    createEstudioLink,
    revokeEstudioLink,
    fetchPublicEstudios,
    submitPublicEstudio,
    updatePublicEstudio,
    deletePublicEstudioAdjunto,
    getAdjuntoUrl,
    getEstudioNotas,
    getPublicUrlAsignacion,
    getEstudioAsignacionLink,
    createEstudioAsignacionLink,
    revokeEstudioAsignacionLink,
    fetchPublicEstudioAsignacion,
    updatePublicAsignacion,
    addPublicEstudioNota,
  }
}
